interface AccordionItem {
  title: string
  text: string
}

interface AccordionDataType {
  [key: string]: AccordionItem[]
}

export const AccordionData: AccordionDataType = {
  'general information': [
    {
      title: 'What is the purpose/goal of these awards?',
      text: "Building on shining examples from our Bright Spots, the Networked Marketing Awards cast a wider net to showcase the year’s stellar initiatives and the remarkable people behind them, pushing our transformation forward and setting new standards for marketing excellence as we are becoming the world's best marketing company. We’re on a mission, and it’s looking pretty epic! 🌟",
    },
    {
      title: "What's new in the 2025 NMA?",
      text: 'This year, the awards are evolving to a network-first, nomination-driven approach designed to do three things: make the process lighter, spotlight the best work faster, and ensure that big ideas (no matter where they come from) can inspire the whole system.',
    },
    {
      title: 'Who is nominating cases?',
      text: 'Standout cases will be nominated by the Global Category teams for most categories, except the Transformation Catalyst and Local Gems. Nominations for the Transformation Catalyst category will be made by global marketing functions (IMX, MTO, MNOC, HI & MP).​ Nominations for the Local Gems category will be made by OU Marketing leads.',
    },
    {
      title: 'Who is eligible for nomination?',
      text: 'Any team from The Coca-Cola Company with winning initiatives launched between Q4 2024 and Q3 2025 qualify for nomination. Once nominated, it’s go-time — your team will have the spotlight to tell the story and bring the case to life. <br><br> Nominations will be announced on October 7, 2025, and submissions are due by October 31, 2025, so get ready to make it count.',
    },
    {
      title: 'I have already been selected as a Bright Spot; am I still eligible to be nominated?',
      text: 'Congrats on your Bright Spot recognition! 🌟 That’s exactly the kind of impact we want to celebrate. Bright Spots are absolutely eligible for nomination.',
    },
    {
      title:
        'What are the important dates related to the awards? (submission deadline, judging period, announcement of winners, awards ceremony, etc.)',
      text: `
      Ooooh it’s going to be an action-packed timeline, so make sure you mark those calendars! 🗓️
        <br> - October 7: Nominated Cases will be announced and case submissions open.
        <br> - October 31: Case submissions close
        <br> - October 31 to November 10: Judging period and & People's Vote
        <br> - December 2: Awards Ceremony and the grand reveal of winners.
`,
    },
  ],
  categories: [
    {
      title: 'What are the different award categories?',
      text: `
      We’ve got 8 award categories and plenty of ways to show off our network's brilliance!
      <br> - Product Experience: awarding the best-in-class product experiences that excel in occasion and ritual building.
      <br> - Live Experience: awarding live brand experiences that break through the clutter and create lasting memories​
      <br> - Digital Experience: awarding standout digital consumer experiences that drive engagement and achieve our strategic digital goals at scale
      <br> - Retail Experience: awarding outstanding E2E commerce experiences that create engagement with shoppers & drive transactions growth.
      <br> - Mind-blowing Creativity: awarding bold creativity that breaks new grounds
      <br> - Innovation: awarding the best innovation in product, packaging and equipment
      <br> - Transformation Catalyst: awarding initiatives that turbocharge our marketing transformation.
      <br> - Local Gem: awarding local creativity serving local or global brands, that leverages local insights to influence consumer sentiment in meaningful ways.
      `,
    },
    {
      title: 'How are award categories defined?',
      text: 'Award categories were defined based on our Marketing Transformation pillars and priorities.',
    },
  ],
  'submission process': [
    {
      title: 'How do I submit my entry?',
      text: 'Once nominations are announced, key contacts will receive an email with details on the submission process and details required. Submissions are made through the <a href="https://networkedmarketingawards.awardsplatform.com/">AwardForce platform</a>, in just a few steps. Simply answer a few questions, upload your case video and a one page key visual, and you\'re done. Good luck!',
    },
    {
      title: 'Can a single team be nominated in several award categories?',
      text: 'Absolutely! Any case may be nominated for a maximum of 2 award categories. Double the exposure, double the fun! 🎉',
    },
    {
      title: 'Is there a specific format the submission for my nominated case needs to be in?',
      text: `
      Yes! Once your case is nominated, you’ll be invited to answer a few questions and submit a short video that brings your project to life — clear, compelling, and straight from the heart.
      <br> Keep it sharp, make it shine, and show us what made your work stand out!
`,
    },
    {
      title:
        'I have a ready deck from previous recognitions; why am I not able to submit it instead of filling a new form?',
      text: "For a level playing field, we've opted for uniformity. This ensures every masterpiece gets an equal shot. It’s all about fairness, folks! ⚖️",
    },
    {
      title: 'Can I edit my submission after it has been submitted?',
      text: 'Absolutely! You’ll be able to come back and update your entry as many times as you want until the submission deadline at midnight ET on October 17. Keep tweaking till it’s just right! ✍️',
    },
  ],
  'judging process': [
    {
      title: 'What criteria are entries judged on?',
      text: 'Entries are judged based on strategy, creative execution, and impact, with varying weighting based on the award categories. ',
    },
    {
      title: 'Who are the judges?',
      text: 'Our panel is a blend of TCCC and WPP leadership. Each award category will have around 5 jury members evaluating submissions.',
    },
    {
      title: 'What is the judging process like?',
      text: 'Submissions  will be reviewed by a jury composed of TCCC and WPP leadership. Jury members will select category winners and share recommendations for the Brave & Boundless Excellence Award with our CMO, Manolo Arroyo. Our CMO, Manolo Arroyo, will determine the final Brave & Boundless Excellence Award winner. It’s like the Lions, but better! 🎥',
    },
    {
      title: 'How are you ensuring that the judging process is fair and inclusive?',
      text: "We've got you! Every entry gets a minimum of 3 judges reviewing it who have no vested interest in the specific case and no connection to the OU or the project. No biases here—just pure marketing excellence! 🌍",
    },
    {
      title: 'Can participants receive feedback on their submissions?',
      text: 'We’d love to. And in case there are any major question marks, we may reach out for clarification. We’re here to help, even if we can’t send individual love notes! 💌',
    },
  ],
  'awards & recognition': [
    {
      title: 'What do winners receive?',
      text: 'Beyond the bragging rights? Winners earn trophies, badges, and a dazzling spotlight on their ingenuity. Who doesn’t love a little extra sparkle? ✨',
    },
    {
      title: 'How will winners be notified?',
      text: "While we'll broadcast the winners live on December 2, each champ will also receive a personalized e-hug and high five (aka email). Who doesn’t love a virtual high five? 🙌",
    },
    {
      title: 'When and where will the awards ceremony be held?',
      text: 'Grab your popcorn for a live broadcast from Atlanta on December 2 at 8:00 AM ET, which will include some live connections to OU offices around the world. It’s going to be a show to remember! 🍿',
    },
    {
      title: 'Will there be a physical trophy or certificate?',
      text: 'Of course! A sleek trophy and a badge to flaunt! Shiny things for your shelf! 🏆',
    },
  ],
  'technical issues & support': [
    {
      title: 'Who can I contact if I have technical difficulties with the submission platform?',
      text: 'No stress! Shoot us an email on networkedmarketingawards@coca-cola.com for any hiccups or questions. We’ve got your back! 💪',
    },
    {
      title: 'Is there a helpline or support email for other queries?',
      text: 'For any other queries, email us on networkedmarketingawards@coca-cola.com —just tag your topic in the subject. We’re here to make sure everything runs smooth 😉',
    },
  ],
  "people's vote": [
    {
      title: 'What’s the People’s Vote all about?',
      text: 'The <bold class="font-bold">People’s Vote</bold> invites us to explore, celebrate, and learn from the inspiring work happening across markets — and to collectively highlight the ideas that best represent our creativity and impact.',
    },
    {
      title: 'How do I cast my vote?',
      text: 'Easy! You’ll pick your <bold class="font-bold">top three cases</bold> in each award category — just like our Jury does, by clicking on <a class="underline cursor-pointer" href="https://networkedmarketingawards.awardsplatform.com/entry/pick?score-set=eNWvzQEk" target="_blank">this link</a>. There’s only one rule: you must vote in <bold class="font-bold">at least three categories</bold> for your votes to count. (We know it’s tough to choose, but the more you explore, the more inspiration you’ll find!) <br/> <br/> <i class="italic">Note: The Local Gem category sits this one out.</i>',
    },
    {
      title: 'Why does the People’s Vote matter?',
      text: 'Because marketing excellence is built together. <br />The People’s Vote brings our network-first mindset to life — combining the expertise of our Jury with the perspectives of our global community. By engaging with the work and sharing your views, you’re helping shape how we define excellence as one network.',
    },
    {
      title: 'How are we making sure it’s fair for everyone?',
      text: 'Fairness is built into the process. Everyone votes for their top three favorites in each category, not just a single winner — ensuring every perspective contributes meaningfully. We’re also calibrating votes to democratize each voice, so no single region or group outweighs another. This helps ensure the outcome reflects our collective view of what great marketing looks like — balanced, inclusive, and truly network-first. <br/> And by asking everyone to vote in <bold class="font-bold">at least three categories</bold> and keeping <bold class="font-bold">Local Gem</bold> out of the People’s Vote, we’re making sure the outcome reflects the best of our collective perspective — not just one corner of the network.',
    },
  ],
}
